
export default {
  name: "Descr",
  inject: {
    specialProject: {
      default: false
    }
  },
  props: {
    text: {
      type: String
    },
    source: {
      type: String
    }
  },
  computed: {
    humanReadableSourceCopyright() {
      if (!this.source) return ""

      try {
        if (this.source) {
          return `${new URL(this.source).origin}`
        }
      } catch {
      }

      return this.source
    },
  },
  mounted() {
    // eslint-disable-next-line nuxt/no-env-in-hooks
    if (process.client && this.source) {
      if (this.$refs.text.children[this.$refs.text.children.length - 1] instanceof HTMLElement) {
        this.$refs.text.appendChild(this.$refs.source)
      }
    }
  }
}
